
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierPurchaseComment.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierPurchaseComment.ts

export class SupplierPurchaseComment {

  // int Id
  public Id: number=0;

  // int SupplierId
  public SupplierId: number=0;

  // string Comment
  public Comment?: string=null;

  // int Deleted
  public Deleted: number=0;

  // int CreaContactId
  public CreaContactId: number=0;

  // DateTime CreaDate
  public CreaDate: Date= new Date();

  // int? UpdateContactId
  public UpdateContactId?: number=null;

  // DateTime? UpdateDate
  public UpdateDate?: Date=null;

  // int? DelContactId
  public DelContactId?: number=null;

  // DateTime? DelDate
  public DelDate?: Date=null;

  // string Screen
  public Screen?: string=null;
}